/* eslint-disable max-len */
import { createFeature, createReducer, createSelector, on } from '@ngrx/store';
import * as luxon from 'luxon';

import * as actions from './qua-full-loading-list.actions';
import { QuaLoadingListI } from 'src/app/api/qua-loading-list/qua-loading-list.result.int';

export interface State {
    error: string;
    loaded: boolean;
    loading: boolean;
    data: QuaLoadingListI;
    receivedTime: string;
    queryString: string;
}

export const initialState: State = {
    error: null,
    loaded: false,
    loading: false,
    data: null,
    receivedTime: null,
    queryString: null,
};

export default createFeature({
    name: 'quaFullLoadingList',
    extraSelectors: ({ selectData }) => ({
        selectContainers: createSelector(
            selectData,
            (data) => data?.containers ?? [],
        ),
    }),
    reducer: createReducer(
        initialState,
        on(actions.error, (state: State, { messageText }): State => ({
            ...state,
            error: messageText,
            loaded: false,
            loading: false,
            queryString: null,
        })),
        on(actions.reset, (state: State): State => ({
            ...state,
            data: null,
            error: null,
            loaded: false,
            loading: false,
            queryString: null,
        })),
        on(actions.received, (state: State, { result }): State => ({
            ...state,
            data: result,
            error: null,
            loaded: true,
            loading: false,
            receivedTime: luxon.DateTime.now().toISO(),
        })),
        on(actions.load, (state: State, { query }): State => ({
            ...state,
            data: null,
            loaded: false,
            loading: true,
            queryString: query?.queryString
        }))
    )
}
);